import React, { useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { buildResultSummary, getPerformanceLevel } from '../../utils/resultSummary';
import { trackButtonClick } from '../../analytics';
import UpgradeCTA from '../../components/UpgradeCTA';
import ResultSummary from '../../components/ResultSummary/ResultSummary';
import StudyPlanCalendar from '../../components/StudyPlanCalendar/StudyPlanCalendar';
import { printLandscape } from '../../utils/printLandscape';
import './TrialResults.css';

const HEADLINE_BY_LEVEL = {
  good: 'Mandou muito bem!',
  medium: 'Bom começo!',
  low: 'Você já deu o primeiro passo!'
};

function TrialResults() {
  const navigate = useNavigate();
  const location = useLocation();
  const { answeredQuestions, plan } = location.state || {};
  const hasResult = Array.isArray(answeredQuestions) && answeredQuestions.length > 0;

  useEffect(() => {
    if (!hasResult) {
      navigate('/simulados', { replace: true });
    }
  }, [hasResult, navigate]);

  const summary = useMemo(() => buildResultSummary(answeredQuestions || []), [answeredQuestions]);

  if (!hasResult) {
    return null;
  }

  const { correct, total, percentage } = summary.overall;
  const level = getPerformanceLevel(percentage);

  return (
    <div className="trial-results-page">
      <div className="containerImage">
        <img src="/logoPreparate.jpeg" alt="logo Preparate" width={180} height={180} />
      </div>

      <h1 className="trial-results-title">Você concluiu sua sessão de treino!</h1>
      <p className="trial-results-subtitle">{HEADLINE_BY_LEVEL[level]}</p>
      
      <UpgradeCTA
        variant="inline"
        trackingPrefix="trial_flow_results"
        title={`Você acertou ${correct} de ${total}!`}
        subtitle="Aproveite a promoção de reta final por apenas R$ 29,90"
        benefits={[
          'Simulados completos cronometrados',
          'Questões comentadas com explicação detalhada',
          'Estatísticas completas de desempenho',
          'Plano de estudos com cronograma semanal completo',
          'Apostilas e leis secas em PDF'
        ]}
      />

      <button
        type="button"
        className="trial-results-secondary"
        onClick={() => {
          trackButtonClick('trial_flow_results_explorar_plataforma');
          navigate('/simulados');
        }}
      >
        Explorar a plataforma
      </button>

      <div className="trial-results-summary">
        <ResultSummary
          summary={summary}
          description="Veja quantos acertos você teve em cada matéria nessa sessão de treino."
        />
      </div>

      {plan && (
        <div className="trial-results-plan">
          <div className="trial-results-plan-header">
            <div>
              <h2 className="trial-results-plan-title">Seu plano de estudos já está pronto e você pode imprimir</h2>
              <p className="trial-results-plan-subtitle">
                Foi com base nele que escolhemos as questões de agora — e é ele que vai guiar sua semana até a prova.
              </p>
            </div>
            <button
              type="button"
              className="trial-results-plan-print"
              onClick={() => {
                trackButtonClick('trial_flow_results_imprimir_plano');
                printLandscape();
              }}
            >
              Imprimir plano
            </button>
          </div>

          <h3 className="trial-results-print-title">Plano de Estudos Personalizado</h3>

          <StudyPlanCalendar plan={plan} />
        </div>
      )}
    </div>
  );
}

export default TrialResults;
